import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getUserApplicationRoutes } from './routes.js';
import { useUserSelectedBranchLocation } from '../hooks/useUserSelectedBranchLocation.js';
import { useUserToken } from '../hooks/useToken.js';
import Unauthorized from '../components/pages/Unauthorized';

const Private_Route = () => {
  // TODO: the auth logic doesn't make any sense, need to correct it.
  const { token } = useUserToken();
  const { selectedLocation } = useUserSelectedBranchLocation();
  const location = useLocation();

  if (token) {
    // Redirect to selection branch location if not selected
    if (!selectedLocation) {
      return <Navigate replace to={'/select-branch-location'} />;
    }

    const userApplicationRoutes = getUserApplicationRoutes(selectedLocation);
    // Restrict access to given route if permission not available
    if (!userApplicationRoutes.includes(location.pathname))
      return <Unauthorized />;

    // Access granted
    return <Outlet />;
  } else {
    return <Navigate to={'/'} />;
  }
};

export default Private_Route;
